import classNames from 'classnames';
import { Size } from './enums';

export const getSizeSubClass = (size: Size): string => classNames({
    sm: size === Size.Small,
    md: size === Size.Medium,
    lg: size === Size.Large,
  });
